import * as actions from "../actions/actionTypes";
import { produce } from "immer";

const initialState = {
  metrics: [],
  selectedMetric: null,
  loading: false,
  errors: [],
  redirect: false,
};

export default produce((draft = initialState, action) => {
  switch (action.type) {
    case actions.CREATE_METRIC_INIT:
      draft.redirect = false;
      draft.selectedEtlConfig = null;
      break;

    case actions.CREATE_METRIC_START:
      draft.loading = true;
      draft.errors = [];
      break;

    case actions.CREATE_METRIC_SUCCESS:
      draft.redirect = true;
      draft.loading = false;
      draft.errors = [];
      break;

    case actions.CREATE_METRIC_FAIL:
      draft.loading = false;
      draft.errors = action.errors;
      break;

    case actions.GET_METRIC_LIST_START:
      draft.loading = true;
      break;

    case actions.GET_METRIC_LIST_SUCCESS:
      draft.loading = false;
      draft.metrics = action.results.data;
      break;

    case actions.GET_METRIC_LIST_FAIL:
      draft.loading = false;
      break;

    case actions.GET_METRIC_START:
      draft.loading = true;
      break;

    case actions.GET_METRIC_SUCCESS:
      draft.loading = false;

      draft.selectedMetric = {
        ...action.results.data,
      };

      break;

    case actions.GET_METRIC_FAIL:
      draft.loading = false;
      break;

    case actions.DELETE_METRIC_SUCCESS:
      draft.metrics = draft.metrics.filter(
        (config) => config.uuid !== action.uuid
      );
      break;

    case actions.UPDATE_METRIC_SUCCESS:
      draft.redirect = true;
      break;

    default:
      return draft;
  }
});
